import React,{PureComponent} from "react";
import autoBind from "react-autobind";
import { Button, Jumbotron, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "../shared/FontAwesomeIconWrapper";

import WebPlayerInternal from "./WebPlayerInternal";
import state from "../../state";
import * as playerActions from "../../actions/playerActions";
import { getQueryStringParam } from "../../utils/utils";

// import { isMobile, isAndroid } from "react-device-detect";

class WebPlayer extends PureComponent {

	constructor(props) {
		super(props);
		const skipNarration = getQueryStringParam("skipNarration");

		let titleCard;
		
		if (global.hasOwnProperty("activities") && global.activities.length > 0) {
			const activity = global.activities[0];
			titleCard = {};
	
			titleCard.title = activity.name;
			titleCard.subtitle = null;
			titleCard.titleBackgroundColor = "white";
			titleCard.titleColor = "black";
	
			if (activity.hasOwnProperty("authorProperties") && activity.authorProperties.hasOwnProperty("titleCard")) {
				titleCard = Object.assign(titleCard, activity.authorProperties.titleCard);
			}
		}

		this.state = {
			confirmedVoice: false,
			skipNarration: !!skipNarration,
			titleCard
		};

		autoBind(this);
		// console.log("WEB PLAYER CONSTRUCTOR");
	}
	async handleChooseVoice(activateVoice) {
		if (activateVoice) {
			await playerActions.setAudioOn();
		} else {
			await playerActions.setAudioOff();
		}
		this.setState({
			confirmedVoice: true,
			activateVoice
		});
	}

	render() {
		let player = null;
		const { confirmedVoice, activateVoice, skipNarration } = this.state;
		if (!confirmedVoice && !this.props.disableVoice && !skipNarration) {
			player = <div className="container" style={{ backgroundColor: "#666666", width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
				<Row>
					<Col xs={12}>
						<Jumbotron>
							{/* {isMobile && 
								<div style={{backgroundColor:"white", padding: "15px", borderRadius: "10px"}}>
									<h3>Mobile Experience</h3>
									<p>AmbiFi provides even a better experience through our mobile app. If you don't have the app, you can download it now.</p>
									{isAndroid && 
											<Button bsSize="large" bsStyle="primary" onClick={() => {
												window.location.href = "https://play.google.com/store/apps/details?id=com.ambifimobile&hl=en_US";
											}}> Go to Google Play</Button>
									}
									{!isAndroid && 
											<Button bsSize="large" bsStyle="primary" onClick={() => {
												window.location.href = "itms-apps://apps.apple.com/us/app/ambifi/id1375015365";
											}}> Go to App Store</Button>
									}
									<div style={{marginTop: "15px"}}>
										<p>If you already have it...</p>
										{isAndroid && 
												<Button bsSize="large" bsStyle="primary" onClick={() => {
												}}> Go to AmbiFi</Button>
										}
										{!isAndroid && 
												<Button bsSize="large" bsStyle="primary" onClick={() => {

												}}> Go to AmbiFi</Button>
										}
									</div>
								</div>
							} */}
							{(this.state.hasOwnProperty("titleCard") && this.state.titleCard) &&
								<div style={{backgroundColor:this.state.titleCard.titleBackgroundColor?this.state.titleCard.titleBackgroundColor:"white", color: this.state.titleCard.titleColor?this.state.titleCard.titleColor:"black", padding: "15px", borderRadius: "10px"}}>
									<h1 style={{textAlign: "center"}}>{this.state.titleCard.title}</h1>
									{this.state.titleCard.subtitle && <h3 style={{textAlign: "center"}}>{this.state.titleCard.subtitle}</h3>}
								</div>
							}
							<div style={{textAlign: "center", padding: "5px"}}>Powered by <a href="https://www.ambifi.com" target="_blank" rel="noopener noreferrer"><img style={{width: "40px"}} alt="AmbiFi Logo" src="https://app.ambifi.com/assets/ambifi-logo.png"/></a></div>
							<h3>Narration</h3>
							<p>Please choose whether you would like Voice Narration or not. You can always de/activate it later.</p>
							<p style={{ width: "100%", display: "flex", justifyContent: "space-evenly" }}>
								<Button bsSize="large" bsStyle="danger" onClick={() => this.handleChooseVoice(false)}><FontAwesomeIcon icon="ban"/> Disable</Button>
								<Button style={{marginLeft: "5px"}} bsSize="large" bsStyle="success" onClick={() => this.handleChooseVoice(true)}><FontAwesomeIcon icon={["fas", "volume-up"]}/> Activate Narration</Button>
							</p>
						</Jumbotron>
					</Col>
				</Row>
			</div>;
		} else {
			player = <WebPlayerInternal activateVoice={activateVoice} {...this.props} />;
		}
		return player;
	}

	setStateValue(path, value) {
		state.set(path, value);
	}

	getStateValue(path) {
		return state.get(path);
	}

	async saveActivity() {
		return playerActions.saveActivity();
	}

	componentWillUnmount() {
		playerActions.cancelVoice();
	}
}

export default WebPlayer;